// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f3c9b53b","453":"af87e92a","454":"452fbb28","754":"248008de","972":"eecd1b6f","991":"d2d2763c"}[chunkId] + ".chunk.js";
};